import React from "react"

const Hero = () => {
  return (
    <section className="page-title page-title-4 bg-dark">
      <div className="background-image-holder">
        <img
          alt="Background"
          className="background-image"
          src="/img/bannertalk.jpg"
        />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h3 className="uppercase mb0 bolder white-text">My Blog</h3>
          </div>
        </div>
        {/* <!--end of row--> */}
      </div>
      {/* <!--end of container--> */}
    </section>
  )
}

export default Hero
